import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";

import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";

import { getEstadosCotizaciones } from "../../../API/Global/Status/StatusRequests";
import { EditarDyeType, getStyleCategory, GuardarDyeType } from "../../../API/Desarrollo/DesarrolloRequest";

const DyeTypeCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [stylesCategory, setStylesCategory] = useState([]);

  const initialValues = {
    IdDyeType: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCotizaciones();
    setEstados(estadosTempo);
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    const stylesTempo = await getStyleCategory();
    setStylesCategory(stylesTempo);

    const styleInicial = modo === "Crear" ? null : stylesTempo.find((e) => e.IdStyleCategory === selected?.IdStylesCategory)

    setValues({
      ...selected,
      IdDyeType: selected ? selected?.IdDyeType : -1,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      StyleCategory: styleInicial,
      IdStyleCategory: styleInicial?.IdStyleCategory,
    });
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.DyeType) {
        error.DyeType = true;
        error.error = true;
    }

    if (modo === "Crear") {
      if (!values.StyleCategory || values.IdStylesCategory) {
        error.IdStyleCategory = true;
        error.error = true;
      }
      if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
    } else {
      if (!values.StyleCategory || !values.IdStylesCategory) {
        error.IdStyleCategory = true;
        error.error = true;
      }
      if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
    }
    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdDyeType: values?.IdDyeType,
        DyeType: values?.DyeType,
        Description: values?.Description,
        IdStylesCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStylesCategory,
        IdStatus: values?.Estado?.IdStatus,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
      };

      setLoading(true);
      if (values?.IdDyeType > 0) {
        const respuesta = await EditarDyeType(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarDyeType(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "agregarTipoC", config.language)}` : `${getLabel(baseLang, "editarTipoC", config.language)}`;

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-5">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="DyeType"
                    value={values.DyeType}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.DyeType ? "p-invalid" : ""}
                  />
                  <label htmlFor="DyeType">{getLabel(baseLang, "tipo", config.language)}</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Description"
                    value={values.Description}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Description ? "p-invalid" : ""}
                  />
                  <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StyleCategory"}
                    value={values.StyleCategory}
                    items={stylesCategory}
                    field={"StyleCategory"}
                    label={getLabel(baseLang, "estilo", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdStyleCategory ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={getLabel(baseLang, "estado", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DyeTypeCRUD;
